import WithGASetup from '../../../components/WithGASetup';
import AuthContext from '../../../context/AuthContext.js';
import DoctorProfilePage from './DoctorProfilePage.js';

export default WithGASetup(DoctorProfilePage, AuthContext);
